export default {
    profile: 'Profile',
    yourAssistant: 'Your assistant',
    yourAssistantTitle: '{name} — your assistant',
    groups: {
        main: 'Main',
        affairs: 'Matters',
        home: 'People & home',
        health: 'Health',
        money: 'Shopping & money',
        beta: 'New versions',
        legacy: 'Old versions',
    },
    descriptions: {
        assistant: 'Say what you’re doing — it’ll log it',
        assistantNamed: 'Your assistant — say what you’re doing and it’ll log it',
        planer2: 'Day, week, tasks',
        basket: 'Shopping list and in-store mode',
        food2: 'Meals, weekly plan, macros',
        forma: 'Sleep, workouts, weight',
        wallet: 'Expenses, payments, budget',
        people: 'Birthdays, gifts, contacts',
        pets: 'Vaccinations, care, weight',
        devices: 'Servicing, warranties, mileage',
        habits: 'Daily check-offs, streaks',
        medications: 'Today’s doses, stock',
        projects: 'Tasks with a goal and a deadline',
        notes: 'Notes with headings and lists',
        places: 'Saved spots on the map',
        food: 'Old meals and plan — replaced by Food',
        shopping: 'Old shopping list — replaced by Groceries',
        finance: 'Old expenses and loans — replaced by Wallet',
        planner: 'Old day and week — replaced by Planner',
    },
    rail: {
        all: 'All',
        current: 'You are here: {name}',
        expand: 'Expand menu',
        collapse: 'Collapse menu',
    },
    bottom: {
        label: 'Navigation',
        more: 'More',
    },
    launcher: {
        title: 'All modules',
        search: 'Search modules and pages…',
        close: 'Close',
        empty: 'Nothing matches “{query}”.',
        pin: 'Pin “{name}” to the menu',
        unpin: 'Unpin “{name}” from the menu',
        isNew: 'New',
        current: 'You are here',
        legacyShow: 'Show old versions',
        legacyHide: 'Hide old versions',
        pinnedCount: 'Pinned: {n}',
        menuSettings: 'Menu settings',
    },
    modules: {
        assistant: 'Assistant',
        planner: 'Planner (old)',
        planer2: 'Planner',
        food: 'Food (old)',
        shopping: 'Shopping (old)',
        basket: 'Groceries',
        food2: 'Food',
        forma: 'Fitness',
        finance: 'Finances',
        wallet: 'Wallet',
        projects: 'Projects',
        notes: 'Notes',
        people: 'People',
        pets: 'Pets',
        devices: 'Devices',
        habits: 'Habits',
        medications: 'Medications',
        places: 'Places',
        settings: 'Settings',
    },
    pages: {
        planer2: {
            day: 'Day',
            week: 'Week',
            month: 'Month',
            tasks: 'Tasks',
            settings: 'Settings',
        },
        food: {
            meals: 'Meals',
            products: 'Products',
            semiProducts: 'Semi-products',
            mealCategories: 'Meal categories',
            daySets: 'Day sets',
            mealPlan: 'Meal plan',
        },
        shopping: {
            list: 'Shopping list',
            shops: 'Shops',
            categories: 'Shop categories',
        },
        basket: {
            toBuy: 'To buy',
            lists: 'Lists and templates',
            shops: 'Shops',
            history: 'History',
            settings: 'Settings',
        },
        food2: {
            today: 'Today',
            week: 'Week',
            meals: 'Meals',
            products: 'Products',
            settings: 'Settings',
        },
        forma: {
            now: 'Now',
            sleep: 'Sleep',
            activity: 'Activity',
            weight: 'Weight',
        },
        finance: {
            overview: 'Overview',
            expenses: 'Expenses',
            incomes: 'Income',
            payments: 'Payments',
            loans: 'Loans',
            categories: 'Categories',
        },
        wallet: {
            now: 'Now',
            transactions: 'Transactions',
            plans: 'Plans',
            analysis: 'Analysis',
            settings: 'Settings',
        },
        projects: {
            projects: 'Projects',
            templates: 'Templates',
        },
        notes: {
            notes: 'Notes',
        },
        people: {
            people: 'People',
        },
        pets: {
            pets: 'Pets',
        },
        devices: {
            devices: 'Devices',
        },
        habits: {
            habits: 'Habits',
        },
        medications: {
            medications: 'Medications',
        },
        places: {
            map: 'Map',
            lists: 'Place lists',
            settings: 'Settings',
        },
        settings: {
            profile: 'Profile',
            goals: 'Goals and preferences',
            calendar: 'Google Calendar',
            menu: 'Menu',
            topBar: 'Top bar',
            app: 'App',
            ai: 'AI usage',
            adminAi: 'AI costs',
        },
    },
    topBar: {
        startScreen: 'Start screen',
        shoppingTitle: 'Go through the list in the shop',
        basketTitle: 'Groceries — default list',
        timersTitle: 'Timers',
        timerDone: 'done',
        phaseEnded: 'Phase over',
        pomodoroPhase: 'Pomodoro — {phase}',
        searchTitle: 'Search (⌘K)',
        noNotifications: 'No notifications',
        timersFinished: 'A timer has finished. | {n} timers have finished.',
        pomodoroFinished: 'Pomodoro: phase over ({phase}).',
        walletHeading: 'WALLET',
        when: {
            overdue: 'overdue',
            today: 'today',
            tomorrow: 'tomorrow',
        },
        paid: 'Paid',
        budgetExceeded: 'Budget “{name}” exceeded by {amount}',
        nothingNew: 'Nothing new.',
        shopping: { label: 'Shopping mode', hint: 'The old shopping list to tick off in the shop, with the item count' },
        basket: { label: 'Groceries', hint: 'Shopping lists — opens the default Groceries list' },
        timers: { label: 'Timer', hint: 'Timers with a countdown in the bar' },
        pomodoro: { label: 'Pomodoro', hint: 'Work and break sessions' },
        search: { label: 'Search', hint: 'Search (also works with ⌘K / Ctrl+K)' },
        notifications: { label: 'Notifications', hint: 'End of a timer or Pomodoro phase' },
    },
    shell: {
        collapse: 'Collapse panel',
        collapseSidebar: 'Collapse sidebar',
        expand: 'Expand panel',
        expandSidebar: 'Expand sidebar',
    },
    search: {
        week: 'Week',
        label: 'Search the app',
        placeholder: 'Where do you want to go?',
        empty: 'Nothing like that here.',
    },
};
